import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';


export async function fetchparameters_status(
    {commit, state},
) {
    await $http
        .get('/api/parametros-por-tabla/107')
        .then(response => {
            commit('setparameters_status', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('modelError', error.message);
        });
}


// Por favor no mover este metodo
export async function searchProducts({state, commit}, model_id = null) {
    let requestParameters = {
        params: state.params
    };

    if (model_id !== null) {
        requestParameters.params.model_id = model_id;
    }

    await $http.get('/api/lista-productos', requestParameters).then(response => {
        commit('setStateProducts', response.data.data);
    });
}

export async function getProductForCode({commit, state, rootState}, code) {
    await $http
        .get(`/api/productos/id/${code}`)
        .then(response => {
            if (response.data.success) {
                state.productEdit = response.data.data.id;
            }
        })
        .catch(error => {
            state.productEdit = null;
            commit('productError', error.message);
        });
}

export async function addProduct({commit, state}) {
    //data_sheets
    await $http
        .post('/api/productos', state.selectedProduct)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'El producto ha sido creado',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('setProduct', response.data.data);
            state.error = false;
        })
        .catch(error => {
            MessageBox.alert(error.message, 'Error', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: 'Aceptar',
                type: 'error',
                customClass: 'notification-error'
            });
            commit('productError', error.message);
        });
}

export async function getProduct({commit, state}, id) {
    if (state.getProductEdit) {
        let params = {
            branchoffice_id: localStorage.selected_branchoffice,
            branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
        };

        await $http
            .get(`/api/productos/${id}/editar`, {params})
            .then(response => {
                commit('setProduct', response.data.data);
                commit('setProductsAttachments', response.data.data.products_attachments);
                if (state.selectedProduct.generic_product){
                    commit('setGenericProducts', [state.selectedProduct.generic_product]);
                }
            })
            .catch(error => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                commit('productError', error.message);
            });

        commit('setGetProductEdit', false);
    }
}

export async function updateProduct({commit, state}) {
    state.selectedProduct.data_sheets = [];
    state.selectedProduct.inventory =  state.inventory;

    state.selectedProduct.inventory.product_id = state.selectedProduct.id
    state.data_sheets.map(item => {
        state.selectedProduct.data_sheets.push({
            value: item.value,
            data_sheet_id: item.data_sheet_id
        });
    });
   /* state.selectedProduct.subcategory_id = state.selectedProduct.subcategory_id_1;*/
    await $http
        .put(`/api/productos/${state.selectedProduct.id}`, state.selectedProduct)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'El producto ha sido actualizado',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('setProduct', response.data.data);
        })
        .catch(error => {
            MessageBox.alert(error.message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            });
            commit('productError', error.message);
        });
}

export function cargaImagenProducto({commit}, image) {
    commit('setImagenCarga', image);
}

export function documentChangePath({commit}, path) {
    commit('setDocumentPath', path);
}

//Descargar documento
export async function downloadDocument({state}) {
    let extension = state.selectedProduct.products_technnical_data.link_data_sheet
        .split('.')
        .pop();
    await $http({
        url: state.selectedProduct.products_technnical_data.link_data_sheet,
        method: 'GET',
        responseType: 'blob' // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                state.selectedProduct.description + '.' + extension
            );
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

export async function fetchSublines(
    {dispatch, state, rootState, commit},
    requestParameters = {params: state.category_params}
) {
    let params = {
        params: {
            lines: state.tableProduct.options.filter_lines,
            filter_brands: state.tableProduct.options.filter_brands
        }
    };

    await dispatch('sublines/listSublines', params, {root: true});
    commit('setSublines', rootState.sublines.sublines);
}

export async function fetchBrands({dispatch, state, rootState, commit}) {
    await dispatch(
        'brands/fetchBrands',
        {
            params: {
                paginate: false,
                lines: state.tableProduct.options.filter_lines
            }
        },
        {root: true}
    );
    commit('setBrands', rootState.brands.brands);
}

export async function fetchSubbrands(
    {dispatch, state, rootState, commit},
    requestParameters = {
        params: state.tableProduct.options
    }
) {
    let params = {
        params: {
            brands: state.tableProduct.options.filter_brands
        }
    };
    await dispatch('subbrands/listSubbrands', params, {
        root: true
    });
    commit('setSubbrands', rootState.subbrands.subbrands);
}

export async function fetchCategories({dispatch, state, rootState, commit}) {
    await dispatch(
        'categories/fetchCategories',
        {
            params: {
                paginate: false,
                lines: state.params.lines
            }
        },
        {
            root: true
        }
    );
    commit('setCategories', rootState.categories.categories);
}

export async function fetchSubcategories({dispatch, state, rootState, commit}, category_id) {
    state.params.category_id = category_id;
    await $http.get('/api/lista-subcategorias', { params: state.params})
        .then((response) => {
            console.log('commit')
            commit('setSubcategoriesMutation', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}

function mapParameters(parameters) {
    return parameters.map(p => {
        return {
            value: p.id,
            label: p.name_parameter
        };
    });
}

//-------Suscriptores-----------//
// Obtiene los tipos de producto
export async function fetchProductType({dispatch, state, rootState, commit}) {
    if (!state.productType.length) {
        await dispatch(
            'parameters/listParameter',
            {
                params: {
                    idParamTable: 13,
                    paginate: false
                }
            },
            {
                root: true
            }
        );
        commit('setProductType', mapParameters(rootState.parameters.parameters));
    }
}

// Obtiene las tallas
export async function fetchSize({dispatch, state, rootState, commit}) {
    if (!state.size.length) {
        await dispatch(
            'parameters/listParameter',
            {
                params: {
                    idParamTable: 17,
                    paginate: false
                }
            },
            {
                root: true
            }
        );
        commit('setSize', mapParameters(rootState.parameters.parameters));
    }
}

// Obtiene los colores
export async function fetchColor({dispatch, state, rootState, commit}) {
    if (!state.color.length) {
        await dispatch(
            'parameters/listParameter',
            {
                params: {
                    idParamTable: 16,
                    paginate: false
                }
            },
            {
                root: true
            }
        );
        commit('setColor', mapParameters(rootState.parameters.parameters));
    }
}

// Obtiene los tipos de rotatcion
export async function fetchRotationType({
                                            dispatch,
                                            state,
                                            rootState,
                                            commit
                                        }) {
    if (!state.rotationType.length) {
        await dispatch(
            'parameters/listParameter',
            {
                params: {
                    idParamTable: 4,
                    paginate: false
                }
            },
            {
                root: true
            }
        ); //TODO: Determinar el idParamTable
        commit('setRotationType', mapParameters(rootState.parameters.parameters));
    }
}

// Obtiene las unidades de aplicación
export async function fetchApplicationUnit({
                                               dispatch,
                                               state,
                                               rootState,
                                               commit
                                           }) {
    if (!state.applicationUnit.length) {
        await dispatch(
            'parameters/listParameter',
            {
                params: {
                    idParamTable: 3,
                    paginate: false
                }
            },
            {
                root: true
            }
        ); //TODO: Determinar el idParamTable
        commit(
            'setApplicationUnit',
            mapParameters(rootState.parameters.parameters)
        );
    }
}

//Exportar archivo para crear productos.
export async function generateFileExport({commit, state}) {
    await $http({
        url: `/api/descargar-plantilla-informe`,
        method: 'GET',
        responseType: 'blob' // important
    }).then(response => {
        var type_file = response.data.type.split('/')[1];

        //Descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `plantilla-crear-productos.${type_file}`);
        document.body.appendChild(link);
        link.click();
    });
}

//Exportar archivo para crear productos.
export async function uploadFileProducts({commit, state}, data) {
    state.errorFileImport = [];
    commit('setChangeStateLoadFile', true);

    await $http
        .post(`/api/productos/ficha-datos/importar/${data.line_id}`, data.file)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: response.data.message.text,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            state.errorFileImport = [];
        })
        .catch(error => {
            //setErrorFileImport
            Notification.error({
                title: 'Error!',
                message: 'Error al importar',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('setErrorFileImport', error.response.data);
        });

    commit('setChangeStateLoadFile', false);
}

//Traemos los data sheets
export async function productsDataSheets({commit, dispatch, state}, id) {
    await $http
        .get(`/api/productos-ficha-datos/${id}`)
        .then(response => {
            commit('setProductsDataSheets', response.data);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Crear una nueva ficha de dato
export async function createProductsDataSheets(
    {commit, state, dispatch},
    data
) {
    await $http
        .post(`/api/ficha-datos-productos/`, data)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('productsDataSheets', data.product_id);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Actualizar ficha de dato del producto
export async function updateProductsDataSheets(
    {commit, state, dispatch},
    data
) {
    await $http
        .put(`/api/ficha-datos-productos/${data.product_id}`, data.value)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('productsDataSheets', data.product_id);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Eliminar ficha de dato del producto
export async function deleteProductsDataSheets(
    {commit, state, dispatch},
    data
) {
    await $http
        .delete(
            `/api/ficha-datos-productos/${data.product_id}?data_sheet_id=${data.data_sheet_id}`
        )
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('productsDataSheets', data.product_id);
        })
        .catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/*
 * Estos metodos se encargar de traer la infromacion para
 * mostrar en la tabla de productos.
 *
 * @author Kevin Galindo
 */
export async function getProductsTable({commit, state}) {
    state.tableProduct.loading = true;

    let params = state.tableProduct.options;

    params.branch_office_id = localStorage.selected_branchoffice;
    params.branch_office_warehouse_id = localStorage.selected_branchoffice_warehouse;

    await $http
        .get(`/api/tabla-productos/`, {params})
        .then(response => {
            commit('setProductsTable', response.data);
        })
        .catch(error => {
            console.error(error);
        });

    state.tableProduct.loading = false;
}

//Este metodo se encarga de guardar un producto.
export async function createProduct({commit, state}) {
    state.selectedProduct.data_sheets = [];

    state.data_sheets.map(item => {
        state.selectedProduct.data_sheets.push({
            value: item.value,
            data_sheet_id: item.data_sheet_id
        });
    });

    return await new Promise(async (resolve, reject) => {
        await $http
            .post('/api/productos', state.selectedProduct)
            .then(response => {
                Notification.success({
                    title: 'Exito!',
                    message: 'El producto ha sido creado',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                commit('setProduct', response.data.data);
                resolve(response.data.data.id);
            })
            .catch(error => {
                MessageBox.alert('Error en la creación del producto', 'Error', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'Aceptar',
                    type: 'error',
                    customClass: 'notification-error'
                });
                reject();
            });
    });


}

//Eliminar productos
export async function deleteProduct({commit, state}, id) {
    await $http
        .delete(`/api/productos/${id}`)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'El producto ha sido eliminado',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            let data = error.response.data.message;
            Notification.error({
                title: 'Error!',
                message: 'No se pudo eliminar el producto: ' + data,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function getParameterByTable({commit, state}, data) {
    state.parametersByTable = [];
    let response = await $http.get(
        `/api/parametros-por-tabla/${data.paramtable_id}`
    );
    if (response.status == 200) {
        commit('setParametersTableInRow', {
            data: response.data,
            row: data.row,
            paramtable_id: data.paramtable_id
        });
    }
}

export async function fetchLines({dispatch, state, rootState, commit}) {
    if (!state.lines.length) {
        await dispatch(
            'lines/fetchLines',
            {params: {paginate: false}},
            {root: true}
        );
        commit('setLines', rootState.lines.lines);
    }
}

export async function fetchProviders({commit}, filter) {
    await $http
        .get('/api/lista-proveedores?filter='+filter)
        .then(response => {
            commit('setProviders', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchRotationClassification(
    {commit, state},
) {
    await $http
        .get('/api/parametros-por-tabla/117')
        .then(response => {
            commit('setRotationClassification', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('modelError', error.message);
        });
}

export async function reportGenerate({}) {
    await $http({
        url: '/api/reporte-productos',
        method: 'GET',
        responseType: 'blob' // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'reporte-productos.csv');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

export async function getImages({commit, state}) {
    await $http
        .get(`/api/imagenes-producto/${state.selectedProduct.id}`)
        .then(response => {
            commit('setProductsAttachments', response.data.data);
        })
        .catch(error => {
            let data = error.response.data.message;
            Notification.error({
                title: 'Error!',
                message: 'No se pudo eliminar el producto: ' + data,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


export async function deleteImage({dispatch, commit, state}, product_attachment_id) {
    await $http
        .delete(`/api/imagenes-producto/${product_attachment_id}`)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'La imagen ha sido eliminada',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('getImages');
        })
        .catch(error => {
            let data = error.response.data.message;
            Notification.error({
                title: 'Error!',
                message: 'Error al eliminar la imagen',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function setMainToImage({dispatch, commit, state}, product_attachment_id) {
    await $http
        .put(`/api/imagenes-producto/${product_attachment_id}`)
        .then(response => {
            Notification.success({
                title: 'Exito!',
                message: 'La imagen principal ha cambiado',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('getImages');
        })
        .catch(error => {
            let data = error.response.data.message;
            Notification.error({
                title: 'Error!',
                message: 'Error al cambiar la imagen principal',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchClassification(
    {commit, state},
) {
    await $http
        .get('/api/parametros-por-tabla/117')
        .then(response => {
            commit('setClassification', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('modelError', error.message);
        });
}

export async function fetchPackingUnits(
    {commit, state},
) {
    let params = {
        params: {}
    };

    await $http
        .get('/api/parametros-por-codigo/120', params)
        .then(response => {
            commit('setPackingUnits', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Cargar imagenes al servidor 1 a 1
export async function loadProductImage({commit, state}, manage_previus_code_system = false) {

    var images = state.loadImages.images;

    // Seteamos los errores
    state.loadImages.errors.has = false;
    state.loadImages.errors.message = [];

    // Recorremos las imagenes y enviamos una a una
    for (var i = 0; i < images.length; i++) {
        var formData = new FormData();
        formData.append('image', images[i]);
    //Sene viar el campo para validar si tambien se busca el producto por codifo sitema anterior
        formData.append('manage_previus_code_system', manage_previus_code_system);

        await $http.post('/api/cargar-imagenes-producto', formData)
            .then((response) => {
                state.loadImages.loadedQuantity++;

            })
            .catch((error) => {
                state.loadImages.errors.has = true;
                state.loadImages.errors.message.push(error.response.data.message);
            });
        state.loadImages.processedQuantity++;
    }

    // Lanzamos una notificacion
    Notification.info({
        title: 'Info!',
        message: 'Proceso del cargue finalizado',
        type: 'info',
        duration: 3000,
        customClass: 'notification-box',
    });
}

/**
 * Request para obtener datos de products_combo.
 */
export async function getProductsCombo({commit, state}, filter = 3) {

    if (filter.length >= 3) {
        let branch_office_id = localStorage.getItem('selected_branchoffice');
        let branch_office_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

        let params = {
            filter,
            mode: true,
            branch_office_id: Number(branch_office_id),
            branch_office_warehouse_id: Number(branch_office_warehouse_id)
        };

        await $http.get('/api/buscar-productos', {params})
            .then((response) => {
                commit('setProductsCombo', response.data.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

/**
 * Request para guardar datos de products_combo.
 */
export async function saveProductCombo({commit, state, dispatch}) {

    let data = state.product_combo

    data.combo_id = state.selectedProduct.id

    await $http.post('/api/producto-combo', data)
        .then((response) => {
            commit('setGetProductEdit', true);
            dispatch('getProduct', state.selectedProduct.id)
            commit('setShowToModalCombos', false);
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


/**
 * Request para actualizar datos de products_combo.
 */
export async function updateProductCombo({commit, state, dispatch}, product_combo) {

    await $http.put('/api/producto-combo/' + product_combo.id, product_combo)
        .then((response) => {
            commit('setGetProductEdit', true);
            dispatch('getProduct', state.selectedProduct.id)
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Request para eliminar datos de products_combo.
 */
export async function deleteProductCombo({commit, state, dispatch}, product_combo) {

    await $http.delete('/api/producto-combo/' + product_combo.id)
        .then((response) => {
            commit('setGetProductEdit', true);
            dispatch('getProduct', state.selectedProduct.id)
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Request para guardar datos de precio.
 */
export async function updatePrice({commit, state, dispatch}) {

    let data = {
        informative_discount_percentage: state.selectedProduct.informative_discount_percentage,
        price: state.selectedProduct.sale_price,
        product_id: state.selectedProduct.id
    }

    await $http.post('/api/actualizar-precio-combo', data)
        .then((response) => {
            commit('setGetProductEdit', true);
            dispatch('getProduct', state.selectedProduct.id)
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 3000,
                customClass: 'notification-box'
            });
        })
        .catch((error) => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener los tipos de productos.
 */
export async function fetchTypes({commit, state}) {
    await $http
        .get('/api/parametros-por-codigo/118')
        .then(response => {
            commit('setTypes', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener los productos genéricos.
 */
export async function fetchGenericProducts({commit, state}, filter) {

    const params = {filter}

    await $http
        .get('/api/productos-genericos', {params})
        .then(response => {
            commit('setGenericProducts', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}
/**
 * Obtener listas de precios.
 */
export async function fetchPriceLists({commit, state}) {

    await $http
        .get('/api/parametros-por-codigo/LDP')
        .then(response => {
            commit('setPriceLists', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener precio.
 */
export async function fetchPrice({commit, state}) {

    let params = state.price

    params.product_id = state.selectedProduct.id;

    await $http
        .get('/api/precio-producto-lista-precios', {params})
        .then(response => {
            if (response.data.data) {
                commit('setPrice', response.data.data);
            }else{
                commit('setPrice', {
                    price_list_id: state.price.price_list_id,
                    price: 0,
                    product_id: state.selectedProduct.id
                });
            }
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Actualizar precio.
 */
export async function updateOrCreatePrice({commit, state}) {

    await $http
        .post('/api/precio-producto-lista-precios', state.price)
        .then(response => {
            Notification.success({
                title: 'Muy bien!',
                message: 'Precio actualizado exitosamente',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function getBranchsWarehouses({commit, state}) {

    await $http.get('/api/branchs-ware').then(response => {
           commit('setBranchsWarehouses', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * @author Brayan Ramirez
 * Obtener el valor del inventario por id de producto
 */
export async function getInventoryByProductId({commit, state}, params) {

    await $http.get('/api/get-inventory-by-product',{params: params}).then(response => {
        if (response.data && response.data.id ){
            commit('setProductInventory', response.data);
        }else{
             state.inventory.product_id = state.selectedProduct.id,
             state.inventory.minimum_stock = '',
             state.inventory.maximum_stock = '',
             state.inventory.location = ''
        }
    })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}
/**
 * @author Brayan Ramirez
 * Obtener la Información del subscriptor
 */
export async function getSubscriber({commit, dispatch, state}) {
    await $http.get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}
/**
 * @author Brayan Ramirez
 * Obtener el cofigo mas grande de la tabla prodcuts
 */

/**
 * Obtener la configuración de Clasificación de rotación
 */
export async function fetchParametersRotationClassification ({ commit }) {
    await $http.get(`/api/parametros-por-codigo/117`)
        .then((response) => {
            commit('setParametersRotationClassification', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function getMaxCodeProduct({commit, dispatch, state}) {
    await $http.get(`/api/products-max-code`)
        .then(response => {
            //usamos una exprecion regular para validar que sea un dato no alfanumerico
            const numberPattern = /^-?\d+(\.\d+)?$/;
            const isValid = numberPattern.test(response.data.max_code)

            if (isValid){
                commit('setCodeProduct', response.data.max_code);
            }else{
                Notification.warning({
                    title: 'Error!',
                    message: 'No se puede suguerir un codigo de producto, la información contene datos alfanumericos',
                    type: 'warning',
                    duration: 1500,
                    customClass: 'notification-box'
                });
            }

        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * @author Brayan Ramirez
 * Verifica si existe un produto con ese codigo
 */

export async function getExistsProduct({commit, dispatch, state},code_product) {
    try {
        console.log('Valida el código:', code_product);
        const response = await $http.get('/api/validate-exist-product-by-code', { params: { code_product } });
        return  response.data.exist;

    } catch (error) {
        console.error(error.response);
        return false;
    }
}

/**
 * @author Brayan Ramirez
 * Valida que el codigo del producto no existe de lo contrario agrega 1
 */

export async function validateProductCodeUntilFalse({ commit,dispatch,state }) {
    let exists;
    do {
        exists = await dispatch('getExistsProduct', state.selectedProduct.code);
        if (exists) {
            commit('setCodeProduct',state.selectedProduct.code);
        }
    } while (exists);
}

export async function getAuditProduct({ commit }, id) {
    await $http
      .get(`/api/auditoria-producto/${id}`)
      .then(response => {
        commit("setAudit", response.data.data);
      })
      .catch(error => {
        Notification.error({
          title: "Error!",
          message: error.message,
          type: "error",
          duration: 1500,
          customClass: "notification-box"
        });
      });
}


/**
 * Vehicles
 */
export async function fetchVehicleBrands({ commit }, params) {
    await $http
        .get("/api/vehicles/brands", { params })
        .then(response => {
            commit("setVehicleBrands", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchVehicleModels({ commit }, params) {
    await $http
        .get("/api/vehicles/models", { params })
        .then(response => {
            commit("setVehicleModels", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchVehicleYears({ commit }, params) {
    await $http
        .get("/api/vehicles/years", { params })
        .then(response => {
            commit("setVehicleYears", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchVehicleEngineDisplacements({ commit }, params) {
    await $http
        .get("/api/vehicles/engine-displacements", { params })
        .then(response => {
            commit("setVehicleEngineDisplacements", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchVehicleTransmissions({ commit }, params) {
    await $http
        .get("/api/vehicles/transmissions", { params })
        .then(response => {
            commit("setVehicleTransmissions", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

// creates
export async function createVehicleBrand({ dispatch }, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post("/api/vehicles/create-brand", payload)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: payload.id ? "Marca Actualizada con Exito!" : "Marca Creada con Exito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function createVehicleModel({ dispatch }, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post("/api/vehicles/create-model", payload)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: payload.id ? "Modelo Actualizada con Exito!" : "Modelo Creada con Exito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function createVehicleYear({ dispatch }, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post("/api/vehicles/create-year", payload)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: payload.id ? "Año Actualizada con Exito!" : "Año Creada con Exito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function createVehicleEngineDisplacement({ dispatch }, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post("/api/vehicles/create-engine-displacement", payload)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: payload.id ? "Cilindraje Actualizada con Exito!" : "Cilindraje Creada con Exito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function createVehicleTransmission({ dispatch }, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post("/api/vehicles/create-transmission", payload)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: payload.id ? "Transmisión Actualizada con Exito!" : "Transmisión Creada con Exito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

// create vehicle product
export async function createProductVehicle(_, payload) {
    return await new Promise(async (resolve, reject) => {
        await $http.post('/api/vehicles/products/link', payload)
            .then(response => {
                Notification.success({
                    title: 'Éxito!',
                    message: 'Creado correctamente',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve(response.data.data);
            })
            .catch(error => {
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : error.message;

                Notification.error({
                    title: 'Error!',
                    message: msg,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box'
                });
                reject(error);
            });
    });
}

export async function fetchProductVehicles({ commit }, product_id) {
    await $http.get(`/api/vehicles/products/${product_id}/linked`)
        .then(response => {
            commit('setProductVehicles', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

export async function fetchProductInheritVehicles({ commit }, product_id) {
    await $http.get(`/api/vehicles/products/${product_id}/linked`)
        .then(response => {
            commit('setProductInheritVehicles', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

export async function deleteProductVehicle(_, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/product-vehicle/${id}`)
            .then(() => {
                Notification.success({
                    title: '¡Éxito!',
                    message: 'La relación ha sido eliminada',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve();
            })
            .catch(error => {
                Notification.error({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}

export async function deleteAllProductVehicles(_, product_id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/product-vehicle-delete-all/${product_id}`)
            .then(() => {
                Notification.success({
                    title: '¡Éxito!',
                    message: 'Todas las relaciones fueron eliminadas',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve();
            })
            .catch(error => {
                Notification.error({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}

export async function fetchInheritVehiclesProducts({ commit, state }, options) {
    const params = {
        branch_office_id: localStorage.selected_branchoffice,
        branch_office_warehouse_id: localStorage.selected_branchoffice_warehouse,
        ...options
    }

    await $http
        .get(`/api/tabla-productos`, { params })
        .then(response => {
            commit("setInheritVehiclesProducts", response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

export async function linkMultipleProductVehicles(_, items) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .post('/api/vehicles/product-vehicles-bulk-link', { items })
            .then(response => {
                Notification.success({
                    title: '¡Éxito!',
                    message: 'Las relaciones fueron creadas',
                    type: 'success',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                resolve(response.data.created);
            })
            .catch(error => {
                Notification.error({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                    duration: 2000,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}


// delete
export async function deleteVehicleBrand({ dispatch }, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/delete-brand/${id}`)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: "Marca Eliminada con Éxito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function deleteVehicleModel({ dispatch }, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/delete-model/${id}`)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: "Modelo Eliminado con Éxito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function deleteVehicleYear({ dispatch }, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/delete-year/${id}`)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: "Año Eliminado con Éxito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function deleteVehicleEngineDisplacement({ dispatch }, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/delete-engine-displacement/${id}`)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: "Cilindraje Eliminado con Éxito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}

export async function deleteVehicleTransmission({ dispatch }, id) {
    return await new Promise(async (resolve, reject) => {
        await $http
            .delete(`/api/vehicles/delete-transmission/${id}`)
            .then(response => {
                Notification.success({
                    title: "Success!",
                    message: "Transmisión Eliminada con Éxito!",
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.id);
            })
            .catch(error => {
                Notification.error({
                    title: "Error!",
                    message:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });
                reject(error);
            });
    });
}


// WEBPACK FOOTER //
// ./src/modules/products/actions.js